/* Mens Ring PDP — gallery, native width/finish/size variants, sticky ATC w/ size guard,
   delivery estimator, engraving-express guard (BCPO), swatch width handshake.
   "finish" = the product's third option axis (Inlay, Color, Plating, Stone…) when it has one;
   it is a VARIANT on this product, so it selects in place — the .mrp-color-dot links are a
   separate, cross-product mechanism (design_family siblings) and stay untouched. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- data ---------- */
  var variants = [];
  try { variants = JSON.parse(($('#mrpVariants') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var hasWidth = variants.some(function (v) { return v.w; });
  var hasFinish = variants.some(function (v) { return v.f; });

  /* ---------- title clamp ---------- */
  var title = $('#mrpTitle'), more = $('#mrpTitleMore');
  if (title && more) {
    if (title.scrollHeight > title.clientHeight + 2) more.hidden = false;
    more.addEventListener('click', function () {
      var open = title.classList.toggle('expanded');
      more.textContent = open ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- gallery ---------- */
  var slides = $$('.mrp-slide'), thumbs = $$('.mrp-thumb');
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function armVideo(vid) {
    /* the gallery <video> is preload="none" and holds its poster in data-poster (PageSpeed decisions 3 and 15): poster and clip load only once its slide is opened */
    if (!vid.poster && vid.dataset.poster) vid.poster = vid.dataset.poster;
    coverVideo(vid);
  }
  /* Blue-frame fix, 2026-10-17: the video's own background is navy, and it showed whenever the slide opened before the
     poster or the first frame was ready. Paint the poster, and under it the gallery thumbnail the shopper already has, as
     the video's background, so the slide shows the picture at once. The thumbnail is already downloaded, so this costs
     nothing extra. It runs again when the slide opens, in case the thumbnail finished loading after the first call. */
  function coverVideo(vid) {
    var slide = vid.closest('.mrp-slide');
    var th = slide && document.querySelector('.mrp-thumb[data-idx="' + slide.getAttribute('data-idx') + '"] img');
    var urls = [vid.dataset.poster];
    if (th && th.complete && th.naturalWidth) urls.push(th.currentSrc || th.src);
    var bg = urls.filter(Boolean).map(function (u) { return 'url("' + u + '")'; }).join(', ');
    if (!bg || vid._feCover === bg) return;
    vid._feCover = bg;
    vid.style.backgroundImage = bg;
    vid.style.backgroundSize = 'contain';
    vid.style.backgroundPosition = 'center';
    vid.style.backgroundRepeat = 'no-repeat';
  }
  function autoplaySlideVideo(vid) {
    armVideo(vid);
    /* video slide selected: start it muted (autoplay-safe); skipped for reduced motion */
    if (reduceMotion || !vid.paused) return;
    vid.muted = true;
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
  }
  function showSlide(i) {
    slides.forEach(function (s) {
      var on = +s.dataset.idx === i, vid = s.querySelector('video');
      s.classList.toggle('active', on);
      if (!vid) return;
      if (on) { autoplaySlideVideo(vid); } else { vid.pause(); s.classList.remove('playing'); }
    });
    thumbs.forEach(function (t) { t.classList.toggle('active', +t.dataset.idx === i); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(+t.dataset.idx); centerThumb(); }); });
  /* arrow / swipe navigation — step through slides; keep the active thumb in view
     when the mobile thumb row scrolls (horizontal only, never scrolls the page) */
  function centerThumb() {
    var at = thumbs.filter(function (t) { return t.classList.contains('active'); })[0];
    var tw = at && at.parentElement;
    if (!tw || tw.scrollWidth <= tw.clientWidth) return;
    var target = at.offsetLeft - (tw.clientWidth - at.offsetWidth) / 2;
    if (tw.scrollTo) { tw.scrollTo({ left: target, behavior: 'smooth' }); } else { tw.scrollLeft = target; }
  }
  function stepSlide(d) {
    var n = slides.length;
    if (n < 2) return;
    var a = slides.filter(function (s) { return s.classList.contains('active'); })[0];
    var cur = a ? +a.dataset.idx : 0;
    showSlide(((cur + d) % n + n) % n);
    centerThumb();
  }
  var navPrev = $('.mrp-nav-prev'), navNext = $('.mrp-nav-next');
  if (navPrev) navPrev.addEventListener('click', function () { stepSlide(-1); });
  if (navNext) navNext.addEventListener('click', function () { stepSlide(1); });
  var galMain = document.querySelector('.mrp-main');
  if (galMain && thumbs.length > 1) {
    /* swipe with direction lock: once a touch is moving mostly sideways the page stops scrolling
       vertically (touchmove is cancelled) and the active slide follows the finger; a mostly-vertical
       touch is handed to the browser untouched so the page still scrolls normally */
    var swX = 0, swY = 0, swOn = false, swLock = '', swSlide = null;
    galMain.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swOn = false; return; }
      swOn = true; swLock = ''; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
      swSlide = galMain.querySelector('.mrp-slide.active');
      if (swSlide) swSlide.style.transition = 'none';
    }, { passive: true });
    galMain.addEventListener('touchmove', function (e) {
      if (!swOn) return;
      var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
      if (!swLock) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        swLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (swLock !== 'x') return;
      if (e.cancelable) e.preventDefault();
      if (swSlide) swSlide.style.transform = 'translateX(' + Math.max(-80, Math.min(80, dx * 0.35)) + 'px)';
    }, { passive: false });
    var swEnd = function (e) {
      if (!swOn) return;
      swOn = false;
      if (swSlide) { swSlide.style.transition = 'transform .18s ease'; swSlide.style.transform = ''; }
      var t = e.changedTouches && e.changedTouches[0];
      if (!t || swLock !== 'x') return;
      var dx = t.clientX - swX;
      if (Math.abs(dx) > 48) stepSlide(dx < 0 ? 1 : -1);
    };
    galMain.addEventListener('touchend', swEnd, { passive: true });
    galMain.addEventListener('touchcancel', swEnd, { passive: true });
  }
  /* the playing class follows the element's real state (autoplay, click, or end) */
  slides.forEach(function (slide) {
    var vid = slide.querySelector('video');
    if (!vid) return;
    var syncPlaying = function () { slide.classList.toggle('playing', !vid.paused && !vid.ended); };
    vid.addEventListener('play', syncPlaying);
    vid.addEventListener('pause', syncPlaying);
    vid.addEventListener('ended', syncPlaying);
  });
  $$('.mrp-video-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slide = btn.closest('.mrp-slide'), vid = slide.querySelector('video');
      if (!vid) return;
      if (vid.paused) { armVideo(vid); var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else { vid.pause(); }
    });
  });
  var firstVid = $('.mrp-slide.active video');
  if (firstVid) autoplaySlideVideo(firstVid);
  /* Audit fix 2026-10-17 (Wade saw a blue frame on iPhone before the video), second pass the same day after he still saw
     it on iPhone and desktop: the first pass waited for the whole page to finish loading, and a shopper who opened the
     video sooner beat it. Each gallery video's poster is now fetched as soon as the main photo has loaded, so it never
     competes with that photo, and at once when the shopper first points at, touches or tabs into the gallery. The clip
     itself still loads only when its slide opens. Skipped when the visitor asks to save data; coverVideo() still
     covers that case with the thumbnail. */
  (function () {
    if (navigator.connection && navigator.connection.saveData) return;
    if (!document.querySelector('.mrp-slide video')) return;
    var armed = false;
    var armAll = function () {
      if (armed) return;
      armed = true;
      Array.prototype.forEach.call(document.querySelectorAll('.mrp-slide video'), function (v) { armVideo(v); });
    };
    var soon = function () { setTimeout(armAll, 50); };
    var gal = document.querySelector('.mrp-gallery');
    if (gal) ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (n) { gal.addEventListener(n, armAll, { once: true, passive: true }); });
    var lead = document.querySelector('.mrp-slide.active img');
    if (!lead || (lead.complete && lead.naturalWidth)) soon();
    else { lead.addEventListener('load', soon, { once: true }); lead.addEventListener('error', soon, { once: true }); }
    if (document.readyState === 'complete') soon(); else window.addEventListener('load', soon, { once: true });
  })();
  /* thumb strip: thumbs keep full size and scroll sideways; chevrons only when the strip overflows */
  var tWrap = document.querySelector('.mrp-thumbs-wrap'), tStrip = document.querySelector('.mrp-thumbs');
  if (tWrap && tStrip) {
    var syncTnav = function () {
      var over = tStrip.scrollWidth > tStrip.clientWidth + 1;
      tWrap.classList.toggle('has-overflow', over);
      tWrap.classList.toggle('at-start', tStrip.scrollLeft <= 1);
      tWrap.classList.toggle('at-end', tStrip.scrollLeft + tStrip.clientWidth >= tStrip.scrollWidth - 1);
    };
    tStrip.addEventListener('scroll', syncTnav, { passive: true });
    window.addEventListener('resize', syncTnav);
    window.addEventListener('load', syncTnav);
    syncTnav();
    var tPrev = tWrap.querySelector('.mrp-tnav-prev'), tNext = tWrap.querySelector('.mrp-tnav-next');
    var tScroll = function (d) { var by = Math.max(80, tStrip.clientWidth * 0.8) * d; if (tStrip.scrollBy) { tStrip.scrollBy({ left: by, behavior: reduceMotion ? 'auto' : 'smooth' }); } else { tStrip.scrollLeft += by; } };
    if (tPrev) tPrev.addEventListener('click', function () { tScroll(-1); });
    if (tNext) tNext.addEventListener('click', function () { tScroll(1); });
  }
  var lb = $('#mrpLightbox'), lbImg = $('#mrpLbImg');
  $$('.mrp-slide img[data-zoom]').forEach(function (img) {
    img.addEventListener('click', function () { if (lb) { lbImg.src = img.dataset.zoom; lb.hidden = false; } });
  });
  if (lb) { lb.addEventListener('click', function () { lb.hidden = true; lbImg.src = ''; }); }

  /* ---------- width / finish / size ---------- */
  var widthWrap = $('#mrpWidths'), widthName = $('#mrpWidthName'), sizeSel = $('#mrpSize');
  var finishWrap = $('#mrpFinishes'), finishName = $('#mrpFinishName');
  var finishOptName = ((finishWrap && finishWrap.dataset.opt) || '').trim().toLowerCase();
  var variantInput = $('#mrpVariantId'), atc = $('#mrpAtc'), price = $('#mrpPrice');

  /* ---------- size validation: visible message + a11y state ----------
     The guard below already blocked the add and moved focus, but said nothing — silent to
     sighted users whose selector was off-screen, and invisible to assistive tech.
     SCOPE: this adds the message ONLY. The Add to Cart button's label is left exactly as the
     theme renders it — an earlier attempt to relabel it to "Choose size" was reverted. */
  var sizeErr = null;
  if (sizeSel) {
    sizeErr = document.createElement('div');
    sizeErr.className = 'mrp-size-error';
    sizeErr.setAttribute('role', 'alert');
    sizeErr.textContent = 'Choose a ring size to continue';
    sizeErr.hidden = true;
    /* UX-32 (UX-laws audit 2026-09-08): this is an error, so it wears the site's error red (#BF1515,
       the cart's discount-error color) instead of the sizer's role purple. Only the color changed;
       role="alert" and aria-invalid stay. */
    /* margin-top:0 deliberately — #mrpSize already carries an 8px bottom margin, and these are
       flex siblings so the margins do not collapse. Adding our own made a 16px gap that read as
       belonging to the note below rather than to the selector above. */
    sizeErr.style.cssText = 'color:#BF1515;font-size:.875rem;line-height:1.3;margin-top:0;font-weight:500;';
    sizeSel.insertAdjacentElement('afterend', sizeErr);
  }
  function showSizeError() {
    if (!sizeErr) return;
    sizeErr.hidden = false;
    sizeSel.setAttribute('aria-invalid', 'true');
  }
  function clearSizeError() {
    if (!sizeErr || sizeErr.hidden) return;
    sizeErr.hidden = true;
    sizeSel.removeAttribute('aria-invalid');
  }

  var priceWas = $('#mrpPriceWas'), priceWasAmt = $('#mrpPriceWasAmt'), priceSave = $('#mrpPriceSave');
  var stickySub = $('#mrpStickySub'), stickyBtn = $('#mrpStickyBtn');
  function currentWidth() {
    var sel = widthWrap && widthWrap.querySelector('button.sel');
    return sel ? sel.dataset.w : '';
  }
  function currentFinish() {
    var sel = finishWrap && finishWrap.querySelector('button.sel');
    return sel ? sel.dataset.f : '';
  }
  function buildSizes() {
    if (!sizeSel) return;
    var w = currentWidth(), f = currentFinish(), prev = sizeSel.value;
    var opts = variants.filter(function (v) { return (!hasWidth || v.w === w) && (!hasFinish || v.f === f); });
    var html = '<option value="">Select your size</option>';
    opts.forEach(function (v) { html += '<option value="' + v.s + '"' + (v.a ? '' : ' disabled') + (v.s === prev ? ' selected' : '') + '>' + v.s + (v.a ? '' : ' — sold out') + '</option>'; });
    sizeSel.innerHTML = html;
    if (prev && sizeSel.value !== prev) sizeSel.value = '';
    syncVariant();
  }
  function syncVariant() {
    var w = currentWidth(), f = currentFinish(), s = sizeSel ? sizeSel.value : '';
    var match = variants.filter(function (v) { return (!hasWidth || v.w === w) && (!hasFinish || v.f === f) && (!s || v.s === s); })[0];
    if (match) {
      if (variantInput && String(variantInput.value) !== String(match.id)) variantInput.value = match.id;
      if (price && price.textContent !== match.p) price.textContent = match.p;
      /* compare-at: variants carry cap (crossed-out original) and sv (savings) when on sale — "" otherwise */
      if (price) price.classList.toggle('on-sale', !!match.cap);
      if (priceWas) {
        if (match.cap) {
          if (priceWasAmt && priceWasAmt.textContent !== match.cap) priceWasAmt.textContent = match.cap;
          priceWas.hidden = false;
        } else if (!priceWas.hidden) { priceWas.hidden = true; }
      }
      if (priceSave) {
        if (match.sv) {
          var svTxt = 'Save ' + match.sv;
          if (priceSave.textContent !== svTxt) priceSave.textContent = svTxt;
          priceSave.hidden = false;
        } else if (!priceSave.hidden) { priceSave.hidden = true; }
      }
      if (atc && !atc.disabled) {
        var label = atc.textContent.split('—')[0].trim() + ' — ' + match.p;
        if (atc.textContent !== label) atc.textContent = label;
      }
    }
    if (stickySub) {
      /* sale price only — no crossed-out original here; width+size+two prices wraps the bar on mobile (couples sticky keeps its strikethrough: shorter line, no options) */
      /* no size option on the product (the free ring sizer): just the price, never "choose your size" */
      var st = sizeSel
        ? (hasWidth ? w + ' · ' : '') + (hasFinish ? f + ' · ' : '') + (s ? 'size ' + s : 'choose your size') + (match ? ' · ' + match.p : '')
        : (match ? match.p : '');
      if (stickySub.textContent !== st) stickySub.textContent = st;
    }
    if (stickyBtn) {
      var bt = (s || !sizeSel) ? 'Add to cart' : 'Choose size';
      if (stickyBtn.textContent !== bt) stickyBtn.textContent = bt;
    }
    updateSwatchTargets(w, s);
    syncBcpoSelectors(w, s, f);
  }
  /* BCPO overwrites [name=id] from ITS hidden Width/Finish/Ring-size selectors on their change events —
     drive them to match our native pickers so whatever BCPO computes is always the right variant */
  function syncBcpoSelectors(w, s, f) {
    var form = $('#mrp-form');
    if (!form) return;
    $$('.selector-wrapper', form).forEach(function (g) {
      var t = g.querySelector('.bcpo-title');
      if (!t) return;
      var name = t.textContent.trim().toLowerCase();
      var val = '';
      if (/^width/.test(name)) { val = w; }
      else if (/^ring size/.test(name)) { val = s; }
      else if (finishOptName && name.indexOf(finishOptName) === 0) { val = f; }
      if (!val) return;
      var sel = g.querySelector('select');
      if (sel) {
        if (sel.value === val) return;
        var has = Array.prototype.some.call(sel.options, function (o) { return o.value === val; });
        if (has) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      } else {
        var radio = $$('input[type="radio"]', g).filter(function (r) { return r.value === val; })[0];
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }
  if (widthWrap) {
    $$('button', widthWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', widthWrap).forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        if (widthName) widthName.textContent = b.dataset.w;
        buildSizes();
      });
    });
  }
  if (finishWrap) {
    $$('button', finishWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', finishWrap).forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        if (finishName) finishName.textContent = b.dataset.f;
        buildSizes();
      });
    });
  }
  /* dismiss the prompt as soon as a size is picked, then the theme's original sync */
  if (sizeSel) sizeSel.addEventListener('change', function () { clearSizeError(); syncVariant(); });
  buildSizes();
  /* default to 8mm (most popular) when no explicit width/variant in the URL */
  (function () {
    var p = new URLSearchParams(window.location.search);
    if (!p.get('w') && !p.get('variant') && widthWrap) {
      var btns = $$('button', widthWrap);
      var pref = btns.filter(function (b) { return b.dataset.w === '8mm'; })[0] || btns[btns.length - 1];
      if (pref && !pref.classList.contains('sel')) pref.click();
    }
  })();

  /* ---------- main ATC size guard: never add to cart without a chosen size ----------
     Registered at DOCUMENT capture so it fires before any app handler (BCPO hooks
     add-to-cart itself and its hidden Ring-Size selector supplies a default variant). */
  function needsSize() { return sizeSel && !sizeSel.value; }
  function focusSize() {
    showSizeError();
    sizeSel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { sizeSel.focus(); }, 450);
  }
  function sizeGuard(e) {
    if (!needsSize()) return;
    var onAtc = e.type === 'click' && e.target && e.target.closest && e.target.closest('#mrpAtc');
    var onForm = e.type === 'submit' && e.target && e.target.id === 'mrp-form';
    if (onAtc || onForm) { e.preventDefault(); e.stopImmediatePropagation(); focusSize(); }
  }
  document.addEventListener('click', sizeGuard, true);
  document.addEventListener('submit', sizeGuard, true);

  /* ---------- sticky ATC + size guard ---------- */
  var sticky = $('#mrpSticky');
  if (sticky && atc) {
    function onScroll() { sticky.classList.toggle('show', atc.getBoundingClientRect().bottom <= 0); }
    window.addEventListener('scroll', onScroll); window.addEventListener('resize', onScroll);
    stickyBtn.addEventListener('click', function () {
      if (sizeSel && !sizeSel.value) {
        focusSize();
      } else {
        var form = $('#mrp-form'); if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---------- delivery estimator (cutoff CT + processing + transit, optional Saturdays) ---------- */
  var del = $('#mrpDelivery');
  var engraveDays = 0; /* engraving adds 3 business days of processing */
  function renderDelivery() {
    if (!del) return;
    var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    var addBiz = function (date, days, sat) {
      var d = new Date(date);
      while (days > 0) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow === 0) continue; if (dow === 6 && !sat) continue; days--; }
      return d;
    };
    try {
      var nowCT = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      var sat = del.dataset.saturdays === '1';
      var start = new Date(nowCT);
      if (nowCT.getHours() >= +del.dataset.cutoff) start.setDate(start.getDate() + 1);
      var early = addBiz(start, (+del.dataset.processingMin || 1) + engraveDays + (+del.dataset.transitMin || 3), sat);
      var late = addBiz(start, (+del.dataset.processing || 2) + engraveDays + (+del.dataset.transitMax || 5), sat);
      var out = $('#mrpDeliveryDates'), txt = fmt(early) + ' – ' + fmt(late);
      /* keep the whole date range on one line: without this the break lands between month and
         day ("Sep" / "8"), splitting a date across two lines. The range is ~140px, so it always
         fits even at 320px — it just moves to the next line as a unit. */
      if (out && out.style.whiteSpace !== 'nowrap') out.style.whiteSpace = 'nowrap';
      if (out && out.textContent !== txt) out.textContent = txt;
    } catch (e) { /* keep fallback text */ }
  }
  renderDelivery();

  /* ---------- engraving guard: BCPO injects async, watch the form ---------- */
  var form = $('#mrp-form'), express = $('#mrpExpress'), engraveNote = $('#mrpEngraveNote');
  /* Wade 2026-09-23: approved wording, one line at every width (fits 343px at 12.5px). mergeEngraveBox() below moves
     this line INTO the engraving box, under the input; engravingGuard() still shows it only while the box has text. */
  if (engraveNote) engraveNote.textContent = 'Engraved rings are final sale — no returns or exchanges.';
  /* BCPO renders its own Width + Finish + Ring size selectors (duplicates of our native ones) — hide those groups, keep engraving */
  function hideBcpoDupes() {
    if (!form) return;
    $$('.selector-wrapper', form).forEach(function (g) {
      var t = g.querySelector('.bcpo-title');
      if (!t) return;
      var txt = t.textContent.trim();
      if (/^(width|ring size)/i.test(txt) || (finishOptName && txt.toLowerCase().indexOf(finishOptName) === 0)) g.style.display = 'none';
    });
  }
  function engravingGuard() {
    if (!form) return;
    var filled = $$('input[type="text"], textarea', form).some(function (f) { return f.name !== 'id' && f.value && f.value.trim().length > 0; });
    if (express) express.classList.toggle('engraving-on', filled);
    if (engraveNote) engraveNote.hidden = !filled;
    var extra = filled ? 3 : 0;
    if (extra !== engraveDays) { engraveDays = extra; renderDelivery(); }
  }
  /* Wade 2026-09-10 (UX-laws audit, law 8 - target distance on the men's PDP):
     1. The "Free engraving included / $30 value" badge becomes the header row of the app's engraving
        box (same purple fill and border, so the two read as one object). The app's own label
        "Optional Engraving (22 Characters Max):" is hidden and the limit moves into the placeholder.
        The badge is CLONED into the box and the original hidden, so if the app ever re-renders the
        box the next reassert() simply clones again; with no box (app failed) the original shows.
        The hidden label still supplies the input's accessible name.
     2. The app leaves a 24px margin under the input inside the box; the box padding already gives
        the room, so it is zeroed.
     Together: 254px from the size select to Add to Cart becomes about 172px. */
  if (!document.getElementById('mrp-engrow-css')) {
    var engrowCss = document.createElement('style');
    engrowCss.id = 'mrp-engrow-css';
    engrowCss.textContent =
      '.mrp-engrow .bcpo-label{display:none!important}' +
      '.mrp-engrow .mrp-engrave--head{border:0!important;background:none!important;padding:0!important;margin:0 0 8px!important;border-radius:0!important}';
    document.head.appendChild(engrowCss);
  }
  function mergeEngraveBox() {
    if (!form) return;
    var badge = $('.mrp-engrave:not(.mrp-engrave--head)');
    var wrap = null;
    $$('.selector-wrapper', form).forEach(function (g) {
      var i = g.querySelector('input[type="text"], textarea');
      if (!wrap && i && /engrav/i.test(i.name || '')) wrap = g;
    });
    if (!wrap) { if (badge) badge.style.removeProperty('display'); return; }
    var inp = wrap.querySelector('input[type="text"], textarea');
    if (!wrap.querySelector('.mrp-engrave--head') && badge) {
      var head = badge.cloneNode(true);
      head.classList.add('mrp-engrave--head');
      head.setAttribute('aria-hidden', 'true');
      wrap.insertBefore(head, wrap.firstChild);
      wrap.classList.add('mrp-engrow');
      badge.style.setProperty('display', 'none', 'important');
    }
    if (inp) {
      if (!inp.getAttribute('placeholder')) {
        var title = wrap.querySelector('.bcpo-title');
        var m = title && /\((\d+)\s*Characters?\s*Max\)/i.exec(title.textContent || '');
        /* 2026-10-03: the new option name ("Engraving") carries no limit; fall back to the box's own maxlength */
        var lim = m ? m[1] : (inp.maxLength > 0 ? String(inp.maxLength) : '');
        inp.setAttribute('placeholder', 'Optional' + (lim ? ' · up to ' + lim + ' characters' : ''));
      }
      var box = inp.parentElement;
      if (box && box !== wrap && box.style.getPropertyValue('margin-bottom') !== '0px') box.style.setProperty('margin-bottom', '0px', 'important');
    }
    /* Wade 2026-09-23: the final-sale line is the last row of the box (was under Add to Cart). Moved, not cloned, so the
       guard's hidden toggle and the id keep working; re-run safe (a no-op once it is inside). */
    if (engraveNote && engraveNote.parentElement !== wrap) wrap.appendChild(engraveNote);
  }
  if (form) {
    form.addEventListener('input', engravingGuard);
    /* BCPO injects async in bursts — COALESCE mutations into a trailing run (never drop them),
       write-guards in syncVariant keep this loop-safe. */
    var moScheduled = false;
    function reassert() { try { hideBcpoDupes(); mergeEngraveBox(); engravingGuard(); syncVariant(); } catch (e) { } }
    new MutationObserver(function () {
      if (moScheduled) return;
      moScheduled = true;
      setTimeout(function () { moScheduled = false; reassert(); }, 60);
    }).observe(form, { childList: true, subtree: true });
    reassert();
    /* safety sweep while BCPO settles (it can take up to 60s to inject) */
    var sweeps = 0;
    var sweepTimer = setInterval(function () { hideBcpoDupes(); if (++sweeps >= 60) clearInterval(sweepTimer); }, 1000);
  }

  /* ---------- color swatch width handshake (cross-product design_family links) ---------- */
  function updateSwatchTargets(w, s) {
    $$('.mrp-color-dot[data-targets]').forEach(function (dot) {
      var targets = [];
      try { targets = JSON.parse(dot.dataset.targets); } catch (e) { return; }
      var exact = targets.filter(function (t) { return t.widths.length === 1 && t.widths[0] === w; })[0];
      var multi = targets.filter(function (t) { return t.widths.indexOf(w) !== -1; })[0];
      var pick = exact || multi || targets[0];
      if (pick) { dot.dataset.href = pick.url; dot.title = dot.dataset.name + (multi || exact ? '' : ' — available in ' + pick.widths.join(' & ')); }
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.mrp-color-dot[data-targets]');
    if (!dot) return;
    e.preventDefault();
    var url = dot.dataset.href || dot.getAttribute('href');
    var w = currentWidth(), s = sizeSel ? sizeSel.value : '';
    var q = [];
    if (w) q.push('w=' + encodeURIComponent(w));
    if (s) q.push('s=' + encodeURIComponent(s));
    /* dual-color target: land with its matching pill preselected (arrival matches ?f= case-insensitively) */
    if (dot.dataset.f) q.push('f=' + encodeURIComponent(dot.dataset.f));
    window.location.href = url + (q.length ? (url.indexOf('?') === -1 ? '?' : '&') + q.join('&') : '');
  });
  /* arrival handshake: preselect ?w=, ?f= and ?s= (f matches case-insensitively — dots pass
     downcased metafield colors like 'rose gold' while pill values read 'Rose gold') */
  (function () {
    var p = new URLSearchParams(window.location.search);
    var w = p.get('w'), f = p.get('f'), s = p.get('s');
    if (w && widthWrap) {
      var btn = $$('button', widthWrap).filter(function (b) { return b.dataset.w === w; })[0];
      if (btn) btn.click();
    }
    if (f && finishWrap) {
      var fl = f.trim().toLowerCase();
      var fbtn = $$('button', finishWrap).filter(function (b) { return (b.dataset.f || '').trim().toLowerCase() === fl; })[0];
      if (fbtn) fbtn.click();
    }
    if (s && sizeSel) {
      sizeSel.value = s;
      if (sizeSel.value === s) syncVariant();
    }
  })();

  /* ---------- related products: swap the static fallback for Shopify's per-product recommendations ---------- */
  var relBody = $('[data-csp-recommendations]');
  if (relBody) {
    fetch(relBody.dataset.cspRecommendations, { priority: 'low' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-csp-recommendations]');
        if (fresh && fresh.querySelector('.cs-pcard')) relBody.innerHTML = fresh.innerHTML;
        syncRelNav();
      })
      .catch(function () { /* keep collection fallback */ });
  }

  /* ---------- related-rings slider arrows (desktop mouse users) ---------- */
  var relWrap = $('.cs-rel-slider');
  function syncRelNav() {
    if (!relWrap) return;
    var r = relWrap.querySelector('.cs-prow');
    var prev = relWrap.querySelector('.cs-rel-prev'), next = relWrap.querySelector('.cs-rel-next');
    if (!r || !prev) return;
    prev.disabled = r.scrollLeft <= 4;
    next.disabled = r.scrollLeft >= r.scrollWidth - r.clientWidth - 4;
  }
  if (relWrap) {
    /* native smooth scroll AND rAF are unreliable under this theme's scripts —
       tween with setInterval and land exactly on the target */
    var relTimer = null;
    var relPage = function (dir) {
      var r = relWrap.querySelector('.cs-prow');
      if (!r) return;
      var start = r.scrollLeft;
      var target = Math.max(0, Math.min(start + dir * r.clientWidth * 0.9, r.scrollWidth - r.clientWidth));
      if (relTimer) clearInterval(relTimer);
      var t0 = Date.now(), dur = 320;
      relTimer = setInterval(function () {
        var p = Math.min((Date.now() - t0) / dur, 1);
        var ease = 1 - Math.pow(1 - p, 3);
        r.scrollLeft = start + (target - start) * ease;
        if (p >= 1) {
          clearInterval(relTimer); relTimer = null;
          r.scrollLeft = target;
          syncRelNav();
        }
      }, 16);
    };
    var rp = relWrap.querySelector('.cs-rel-prev'), rn = relWrap.querySelector('.cs-rel-next');
    if (rp) rp.addEventListener('click', function () { relPage(-1); });
    if (rn) rn.addEventListener('click', function () { relPage(1); });
    relWrap.addEventListener('scroll', syncRelNav, true);
    window.addEventListener('resize', syncRelNav);
    syncRelNav();
  }

  /* ---------- sizing help, matched to the couples PDP ----------
     The strongest sizing reassurance this store has is that a sizer ships with the ring — it
     resolves the hesitation without asking anyone to wait. Replaces the guess advice, which
     manufactured the exchanges the guarantee then paid for.
     No product gating needed: .mrp-sizenote is only rendered for products that HAVE a size
     option, so it never appears on the wood ring box (verified — zero occurrences there). */
  var mrpNote1 = $('.mrp-sizenote-1');
  var mrpNote2 = $('.mrp-sizenote-2');
  /* Wade 2026-09-10: one line instead of two (saves 18px above the engraving box), and it must say
     "ring sizer". Copy chosen by measurement: 281px at 12.5px/600 against the 300px note width at
     360px; "Ring sizer ships with every order · free size exchange" is 314px and wraps there. */
  if (mrpNote1) mrpNote1.textContent = '✓ Ring sizer with every order · free size exchange';
  if (mrpNote2) mrpNote2.style.setProperty('display', 'none', 'important');
  /* Ruler icon only — the link is NOT repositioned here. On couples it sat orphaned above both
     dropdowns; on this template it is already inline with the "Ring size" label, which is the
     conventional spot and does not wrap. Moving it would stack a third helper line under the
     selector for no gain. */
  (function () {
    var sizeLink = $('#mrpSizeOpen');
    if (!sizeLink || sizeLink.querySelector('svg')) return;
    sizeLink.style.display = 'inline-flex';
    sizeLink.style.alignItems = 'center';
    sizeLink.style.gap = '6px';
    sizeLink.insertAdjacentHTML('afterbegin',
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="2" y="8" width="20" height="8" rx="1.5"/>' +
      '<path d="M6.5 8v3M10 8v4M13.5 8v3M17.5 8v4"/></svg>');
  })();

  /* ---------- ring sizer modal (full couples-set port: calibration, dial, chart) ---------- */
  var RS_SIZES = [
    {us:'4',dia:14.9,circ:46.8,uk:'H½',eu:47},
    {us:'4.5',dia:15.3,circ:48.0,uk:'I½',eu:48},
    {us:'5',dia:15.7,circ:49.3,uk:'J½',eu:49},
    {us:'5.5',dia:16.1,circ:50.6,uk:'K½',eu:51},
    {us:'6',dia:16.5,circ:51.9,uk:'L½',eu:52},
    {us:'6.5',dia:16.9,circ:53.1,uk:'M½',eu:53},
    {us:'7',dia:17.3,circ:54.4,uk:'N½',eu:54},
    {us:'7.5',dia:17.7,circ:55.7,uk:'O½',eu:56},
    {us:'8',dia:18.1,circ:57.0,uk:'P½',eu:57},
    {us:'8.5',dia:18.5,circ:58.3,uk:'Q½',eu:58},
    {us:'9',dia:18.9,circ:59.5,uk:'R½',eu:60},
    {us:'9.5',dia:19.4,circ:60.8,uk:'S½',eu:61},
    {us:'10',dia:19.8,circ:62.1,uk:'T½',eu:62},
    {us:'10.5',dia:20.2,circ:63.4,uk:'U½',eu:63},
    {us:'11',dia:20.6,circ:64.6,uk:'V½',eu:65},
    {us:'11.5',dia:21.0,circ:65.9,uk:'W½',eu:66},
    {us:'12',dia:21.4,circ:67.2,uk:'Y',eu:67},
    {us:'12.5',dia:21.8,circ:68.5,uk:'Z',eu:69},
    {us:'13',dia:22.2,circ:69.7,uk:'Z+1',eu:70},
    {us:'13.5',dia:22.6,circ:71.0,uk:'Z+2',eu:71},
    {us:'14',dia:23.0,circ:72.3,uk:'Z+3',eu:72},
    {us:'14.5',dia:23.4,circ:73.6,uk:'Z+4',eu:74},
    {us:'15',dia:23.8,circ:74.8,uk:'Z+5',eu:75}
  ];
  var rsModal = $('#rsModal');
  if (rsModal) {
    var rsOpen = $('#mrpSizeOpen');
    var rsCal = $('#rsCal'), rsCard = $('#rsCard'), rsSize = $('#rsSize'), rsRing = $('#rsRing'), rsRead = $('#rsReadout');

    function rsUpdate() {
      if (!rsCal || !rsSize) return;
      var cardPx = +rsCal.value;
      if (rsCard) {
        /* ISO ID-1 card = 85.6mm tall x 53.98mm wide (held upright). Set both
           dimensions explicitly so the short side stays accurate regardless of
           any theme .rs-card overrides. */
        rsCard.style.setProperty('height', cardPx + 'px', 'important');
        rsCard.style.setProperty('width', (Math.round(cardPx * 53.98 / 85.6 * 10) / 10) + 'px', 'important');
        rsCard.style.setProperty('max-width', 'none', 'important');
      }
      var pxPerMm = cardPx / 85.6;
      var s = RS_SIZES[+rsSize.value];
      var d = Math.round(s.dia * pxPerMm);
      if (rsRing) {
        /* the ring's inside diameter should equal the INNER edge of the stroke,
           so grow the (border-box) circle by the stroke width on each side */
        var bw = parseFloat(getComputedStyle(rsRing).borderTopWidth) || 1;
        var outer = d + 2 * bw;
        rsRing.style.width = outer + 'px';
        rsRing.style.height = outer + 'px';
      }
      if (rsRead) rsRead.textContent = 'US ' + s.us + '  ·  ' + s.dia + ' mm  ·  UK ' + s.uk + '  ·  EU ' + s.eu;
    }
    function rsShow(e) {
      if (e && e.preventDefault) e.preventDefault(); /* #mrpSizeOpen carries a real href (/pages/ring-sizer, PageSpeed decision 75); the click stays here and opens the modal */
      rsModal.hidden = false; document.body.style.overflow = 'hidden';
      var hasCal = calApply(); rsUpdate(); applyRefresh();
      dialMoved = false;
      rsTrack('ring_sizer_open', { calibration: hasCal ? 'saved' : 'none' });
    }
    function rsHide() { rsModal.hidden = true; document.body.style.overflow = ''; calRedo = false; }

    /* women's rings run this same script; the template class tells the two apart in GA4 */
    var RS_PAGE = /womens/i.test(document.body.className || '') ? 'womens' : 'mens';
    var MODAL = rsModal, CAL = rsCal, CARD = rsCard, DIAL = rsSize, RING = rsRing, READ = rsRead;
    /* ---------- UX-09 (UX-laws audit 2026-09-08; built at Wade's request 2026-09-11) ----------
       1. The dial's answer goes straight into the size dropdown(s) - see the apply block below.
          Nothing is ever preselected: only a tap fills a size (made to order; engraved rings are final sale).
          A reading the ring is not made in disables the button and names the range instead of rounding to a
          neighbor. All button copy measured to fit one line at 360px.
       2. Step 2 is gated behind an explicit "This matches my card" tap (Wade 2026-09-11; the standalone Ring Sizer page
          uses the same words): until then the circle, dial, answer and apply buttons stay hidden, because a ring matched
          on an uncalibrated screen gives a wrong size. The confirmed calibration is remembered on this device
          (localStorage "fe-rs-card", shared by every ring page; saved only on that tap, never while dragging), so a
          return visit starts with step 1 folded to "1. Screen calibrated ✓ Redo" and step 2 open. Redo reopens step 1
          and gates step 2 again. Keyed on devicePixelRatio: a browser zoom change alters CSS px per mm, so a value saved
          at another zoom level is ignored. Storage can throw (private mode, blocked storage); every access is guarded,
          and the gate still works for the visit - it just is not remembered.
       3. Sizer use is counted in GA4. The Google & YouTube app already runs gtag on the page with the store's GA4 stream
          configured; send_to keeps these events out of the Google Ads tag. Events: ring_sizer_open (calibration
          saved|none), ring_sizer_tab (sizer_tab), ring_sizer_calibrate (card confirmed), ring_sizer_dial (first move of
          the dial per open), ring_sizer_use_size (ring his|her|single, ring_size). Every event carries sizer_page. */
    if (!document.getElementById('rs-ux09-css')) {
      /* .rs-apply max-width 440px: the standalone Ring Sizer page's stylesheet is compiled site-wide and caps
         .rs-readout at 440px from 920px up, so on desktop the buttons match the answer box above them. */
      var ux09Css = document.createElement('style');
      ux09Css.id = 'rs-ux09-css';
      ux09Css.textContent =
        '#rsModal .rs-apply{display:flex;gap:8px;margin:12px 0 0;max-width:440px}' +
        '#rsModal .rs-apply-btn{flex:1 1 0;min-width:0;min-height:44px;border:1.5px solid #4C3799;background:#fff;color:#4C3799;border-radius:12px;font:inherit;font-size:14px;font-weight:600;line-height:1.2;padding:0 8px;white-space:nowrap;cursor:pointer}' +
        '#rsModal .rs-apply-btn.is-set{background:#4C3799;color:#fff}' +
        '#rsModal .rs-apply-btn:disabled{border-color:#DCD9E8;background:#fff;color:#6E6A85;cursor:default}' +
        '#rsModal .rs-apply-btn:focus-visible,#rsModal .rs-redo:focus-visible,#rsModal .rs-calconfirm:focus-visible{outline:2px solid #4C3799;outline-offset:2px}' +
        '#rsModal .rs-calconfirm{display:block;width:100%;min-height:44px;margin:0 0 16px;padding:0 12px;background:#4C3799;color:#fff;border:0;border-radius:12px;font:inherit;font-size:14px;font-weight:600;line-height:1.2;cursor:pointer}' +
        '#rsModal .rs-redo{display:inline-flex;align-items:center;min-height:44px;margin:-12px 0;padding:0 8px;background:none;border:0;font:inherit;font-size:14px;color:#4C3799;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
      document.head.appendChild(ux09Css);
    }
    var rsTrack = function (name, params) {
      try {
        if (typeof window.gtag !== 'function') return;
        var id = 'G-CNG4X1659M', dl = window.dataLayer || [];
        for (var i = 0; i < dl.length; i++) { if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1] || '')) { id = dl[i][1]; break; } }
        var p = { send_to: id, sizer_page: RS_PAGE };
        if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
        window.gtag('event', name, p);
      } catch (e) { }
    };
    var rsNorm = function (t) { var m = /^\s*(\d+)(?:\s+1\/2|\.5)\s*$/.exec(String(t)); return m ? +m[1] + 0.5 : parseFloat(t); };
    var rsFmt = function (v) { return String(v).replace(/\s+1\/2\s*$/, '.5'); };
    var RS_CAL_KEY = 'fe-rs-card';
    var calSaved = function () {
      if (!CAL) return null;
      try {
        var o = JSON.parse(window.localStorage.getItem(RS_CAL_KEY) || 'null');
        if (o && o.dpr === (window.devicePixelRatio || 1) && +o.px >= +CAL.min && +o.px <= +CAL.max) return +o.px;
      } catch (e) { }
      return null;
    };
    var calStore = function () {
      try { window.localStorage.setItem(RS_CAL_KEY, JSON.stringify({ px: +CAL.value, dpr: window.devicePixelRatio || 1, t: Date.now() })); } catch (e) { }
    };
    var dialPanel = MODAL.querySelector('.rs-panel[data-panel="dial"]');
    var rsSteps = dialPanel ? dialPanel.querySelectorAll('.rs-step') : [];
    var calStep = rsSteps[0] || null, step2Head = rsSteps[1] || null;   // "1. Calibrate your screen" / "2. Match a ring you own"
    var calOk = null, calConfirm = null, calRedo = false, dialMoved = false;
    var rsShowEl = function (el, on) { if (!el) return; if (on) el.style.removeProperty('display'); else el.style.setProperty('display', 'none', 'important'); };
    var calApply = function () {
      var px = calSaved();
      if (!calConfirm) return px !== null;   // markup not as expected: leave the sizer exactly as the theme renders it
      var done = px !== null && !calRedo;
      if (done && +CAL.value !== px) CAL.value = px;
      [calStep, CARD, CAL, calConfirm].forEach(function (el) { rsShowEl(el, !done); });
      rsShowEl(calOk, done);
      [step2Head, RING, DIAL, READ, MODAL.querySelector('.rs-apply')].forEach(function (el) { rsShowEl(el, done); });
      return px !== null;
    };
    if (calStep && step2Head && CAL && DIAL) {
      calConfirm = document.createElement('button');
      calConfirm.type = 'button';
      calConfirm.className = 'rs-calconfirm';
      calConfirm.textContent = 'This matches my card';
      CAL.insertAdjacentElement('afterend', calConfirm);
      calConfirm.addEventListener('click', function (e) {
        calStore();
        calRedo = false;
        calApply(); applyRefresh();
        if (e.isTrusted) rsTrack('ring_sizer_calibrate');
        try { DIAL.focus({ preventScroll: true }); } catch (x) { DIAL.focus(); }
      });
      /* A phone-size card box (~480-520px tall once matched) pushes the slider and this button below the sizer's
         visible area. When the shopper lets go of the slider ("change" fires on release), scroll just enough to bring
         the button into view - the gate must never sit offscreen. Not on "input": moving the box mid-drag would
         shift it under the card being held against the screen. */
      CAL.addEventListener('change', function () {
        var d = MODAL.querySelector('.rs-dialog');
        if (!d || calConfirm.style.getPropertyValue('display') === 'none') return;
        var over = calConfirm.getBoundingClientRect().bottom + 12 - Math.min(d.getBoundingClientRect().bottom, window.innerHeight);
        if (over <= 0) return;
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (d.scrollBy && !calm) d.scrollBy({ top: over, behavior: 'smooth' }); else d.scrollTop += over;
      });
      calOk = document.createElement('div');
      calOk.className = 'rs-step rs-calok';
      rsShowEl(calOk, false);
      calOk.innerHTML = '<b>1. Screen calibrated ✓</b> <button type="button" class="rs-redo">Redo</button>';
      calConfirm.insertAdjacentElement('afterend', calOk);
      calOk.querySelector('.rs-redo').addEventListener('click', function () { calRedo = true; calApply(); CAL.focus(); });
    }
    if (DIAL) DIAL.addEventListener('input', function (e) {
      applyRefresh();
      if (e.isTrusted && !dialMoved) { dialMoved = true; rsTrack('ring_sizer_dial'); }
    });
    var rsReading = function () { return DIAL ? RS_SIZES[+DIAL.value].us : null; };

    /* apply (men's / women's): one full-width button, "Use size 10", that fills the size dropdown and closes the sizer.
       The reading is matched against the dropdown the page built for the selected width/finish ("10 1/2" = 10.5), so a
       size this style is not made in, or has sold out in, disables the button with the reason. Longest label at 360px:
       "Size 10.5 is sold out in this style", 201px of the 252px available. */
    var applyBtn = null;
    var sizeOpt = function (us) {
      return sizeSel ? Array.prototype.slice.call(sizeSel.options).filter(function (o) { return o.value && rsNorm(o.value) === rsNorm(us); })[0] || null : null;
    };
    var applyRefresh = function () {
      if (!applyBtn) return;
      var us = rsReading(), o = sizeOpt(us), label, aria, off = false, set = false;
      var opts = Array.prototype.slice.call(sizeSel.options).filter(function (x) { return x.value; });
      if (!o) {
        off = true;
        label = opts.length ? 'This ring comes in ' + rsFmt(opts[0].value) + '–' + rsFmt(opts[opts.length - 1].value) : 'Use size ' + us;
        aria = label + '; US ' + us + ' is not available';
      } else if (o.disabled) { off = true; label = 'Size ' + us + ' is sold out in this style'; aria = label; }
      else if (sizeSel.value === o.value) { set = true; label = '✓ Size ' + us; aria = 'Size ' + us + ' is selected. Close the sizer'; }
      else { label = 'Use size ' + us; aria = 'Use size ' + us + ' and close the sizer'; }
      if (applyBtn.textContent !== label) applyBtn.textContent = label;
      applyBtn.disabled = off;
      applyBtn.classList.toggle('is-set', set);
      applyBtn.setAttribute('aria-label', aria);
    };
    if (rsRead && sizeSel) {
      var applyWrap = document.createElement('div');
      applyWrap.className = 'rs-apply';
      applyWrap.setAttribute('aria-live', 'polite');
      applyBtn = document.createElement('button');
      applyBtn.type = 'button';
      applyBtn.className = 'rs-apply-btn';
      applyBtn.addEventListener('click', function () {
        var us = rsReading(), o = sizeOpt(us);
        if (!o || o.disabled) return;
        if (sizeSel.value !== o.value) {
          sizeSel.value = o.value;
          sizeSel.dispatchEvent(new Event('change', { bubbles: true }));
          rsTrack('ring_sizer_use_size', { ring: 'single', ring_size: us });
        }
        rsHide();
      });
      applyWrap.appendChild(applyBtn);
      rsRead.insertAdjacentElement('afterend', applyWrap);
    }

    if (rsOpen) rsOpen.addEventListener('click', rsShow);
    $$('[data-rs-close]', rsModal).forEach(function (el) { el.addEventListener('click', rsHide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !rsModal.hidden) rsHide(); });

    /* ---------- sizing methods: order fastest-first, then offer the mailed sizer ----------
       Same treatment as the couples PDP. Theme ships print / dial / chart with print landing;
       printable is the only method needing a printer, so it should not be the default. Runs
       BEFORE the tab handlers below so the new tab is wired by the same code as the originals.
       Panel styles are inline — the .rs-btn classes are defined for the standalone sizer page,
       not verified inside this modal. */
    var mrpTabs = $('.rs-tabs', rsModal);
    if (mrpTabs) {
      /* Wade 2026-09-11: all four methods visible at once and the row never moves - same fix and reasoning as
         couples-set.js (the swipeable row hid the free sizer offscreen and could be dragged up and down by a pixel). */
      if (!document.getElementById('rs-tabstrip-css')) {
        var mrpTabCss = document.createElement('style');
        mrpTabCss.id = 'rs-tabstrip-css';
        mrpTabCss.textContent =
          '#rsModal .rs-tabs{display:flex;flex-wrap:wrap;justify-content:space-between;gap:0;overflow:visible}' +
          '#rsModal .rs-tab{white-space:nowrap;flex:0 0 auto;padding-left:6px;padding-right:6px}' +
          '@media (min-width:600px){#rsModal .rs-tabs{justify-content:flex-start;gap:20px}#rsModal .rs-tab{padding-left:12px;padding-right:12px}}';
        document.head.appendChild(mrpTabCss);
      }
      var mrpTab = function (k) { return $('.rs-tab[data-tab="' + k + '"]', rsModal); };
      var mrpPanel = function (k) { return $('.rs-panel[data-panel="' + k + '"]', rsModal); };
      ['dial', 'chart', 'print'].forEach(function (k) {
        var t = mrpTab(k); if (t) { mrpTabs.appendChild(t); t.classList.remove('active'); }
        var p = mrpPanel(k); if (p) p.classList.remove('active');
      });
      var mrpDialTab = mrpTab('dial'), mrpDialPanel = mrpPanel('dial');
      if (mrpDialTab) mrpDialTab.classList.add('active');
      if (mrpDialPanel) mrpDialPanel.classList.add('active');
      /* Wade 2026-09-11: short labels so all four fit one row at 360px */
      var mrpTabLabels = { dial: 'Dial', chart: 'Size chart', print: 'Print' };
      Object.keys(mrpTabLabels).forEach(function (k) { var t = mrpTab(k); if (t) t.textContent = mrpTabLabels[k]; });

      if (!mrpTab('mail')) {
        var mailTab = document.createElement('button');
        mailTab.type = 'button';
        mailTab.className = 'rs-tab';
        mailTab.setAttribute('data-tab', 'mail');
        mailTab.textContent = 'Free ring sizer';
        mrpTabs.appendChild(mailTab);

        var mailPanel = document.createElement('div');
        mailPanel.className = 'rs-panel';
        mailPanel.setAttribute('data-panel', 'mail');
        mailPanel.innerHTML =
          '<div style="background:#F7F4FC;border-radius:10px;padding:14px;">' +
            '<p style="margin:0 0 6px;font-size:14px;font-weight:500;color:#3C3489;">Rather size before you order?</p>' +
            '<p style="margin:0 0 12px;font-size:13px;line-height:1.5;color:#534AB7;">We\'ll mail you a free plastic sizer with $5 credit toward your ring. US only. A sizer also ships with every ring order.</p>' +
            '<button type="button" data-rs-mail-add="45538170404995" style="width:100%;background:#4C3799;color:#fff;border:0;border-radius:12px;padding:12px;font:inherit;font-size:14px;font-weight:500;cursor:pointer;">Get a free ring sizer</button>' +
          '</div>';
        var mrpPanels = $$('.rs-panel', rsModal);
        var mrpLast = mrpPanels[mrpPanels.length - 1];
        if (mrpLast && mrpLast.parentElement) mrpLast.parentElement.appendChild(mailPanel);

        /* Not a <form action="/cart/add"> on purpose. The Best Custom Product Options app
           hooks every add-to-cart form on the page and runs the RING's required option
           validation against it, so the sizer's native POST never fired: the click only
           produced a "Please select an item in the list" bubble on the size dropdowns
           behind the modal. Add the sizer through cart/add.js instead and hand the
           result to the theme the same way its own product-form does (bundled drawer
           section + cart:change), so the cart drawer refreshes and opens. Falls back to
           the GET permalink (full page to /cart) if anything in that path fails. */
        var mailAdd = mailPanel.querySelector('[data-rs-mail-add]');
        if (mailAdd) mailAdd.addEventListener('click', function () {
          if (mailAdd.getAttribute('aria-busy') === 'true') return;
          var vid = mailAdd.getAttribute('data-rs-mail-add');
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var fallback = function () { window.location.href = root + 'cart/add?id=' + vid + '&quantity=1'; };
          if (!window.fetch || !window.FormData) { fallback(); return; }
          mailAdd.setAttribute('aria-busy', 'true');
          var sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
          var fd = new FormData();
          fd.set('id', vid);
          fd.set('quantity', '1');
          fd.set('sections', sections.join(','));
          fd.set('sections_url', root + 'variants/' + vid);
          fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'add failed'); return j; }); })
            .then(function (added) {
              var st = (window.themeVariables && window.themeVariables.settings) || {};
              if (st.cartType === 'page' || st.pageType === 'cart') { window.location.href = root + 'cart'; return; }
              return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                cart.sections = added.sections || {};
                rsHide();
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
              });
            })
            .catch(fallback)
            .then(function () { mailAdd.removeAttribute('aria-busy'); });
        });
      }
    }

    $$('.rs-tab', rsModal).forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        $$('.rs-tab', rsModal).forEach(function (x) { x.classList.remove('active'); });
        $$('.rs-panel', rsModal).forEach(function (x) { x.classList.remove('active'); });
        tab.classList.add('active');
        var p = rsModal.querySelector('.rs-panel[data-panel="' + tab.getAttribute('data-tab') + '"]');
        if (p) p.classList.add('active');
        if (e && e.isTrusted) rsTrack('ring_sizer_tab', { sizer_tab: tab.getAttribute('data-tab') });
      });
    });

    if (rsCal) rsCal.addEventListener('input', rsUpdate);
    if (rsSize) rsSize.addEventListener('input', rsUpdate);

    var rsBody = $('#rsChartBody');
    if (rsBody && !rsBody.children.length) {
      RS_SIZES.forEach(function (s) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + s.us + '</td><td>' + s.dia + ' mm</td><td>' + s.circ + ' mm</td><td>' + s.uk + '</td><td>' + s.eu + '</td>';
        rsBody.appendChild(tr);
      });
    }
  }
})();